import { getConfigParam } from './config'

export const apiUrl = (path: string) => {
  return `${getConfigParam('REACT_APP_API_URL')}${path}`
}
